<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="الإهــداء">
<h1><span dir="rtl">الإهــداء</span></h1>
<p><span dir="rtl">إهداءٌ إلى كلِّ قلبٍ يحتضنُ التفاؤلَ بين ثناياه، إلى كلِّ سطرٍ يبعثُ الحبَّ من حروفه، إلى كلِّ عينٍ لا تبصرُ إلّا النور، إلى كلِّ شمعةٍ تصارع ظلامَ عالمنا، إلى كلِّ سفينةٍ لم تصل إلى موانئ السّعادة، إلى كلِّ غصنٍ لم يعانق أسرابَ الأحلام، إلى كلِّ قلم لم يعرف إلّا السوادَ لوناً،</span> <span dir="rtl">إلى عالمنا..</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?1385c118